import { useContext } from 'react';
import { TransparentOverlayContext } from './transparent-overlay-context';

export const useTransparentOverlay = () => {
  return useContext(TransparentOverlayContext);
};
